import { render, staticRenderFns } from "./WidgetMenu.vue?vue&type=template&id=51c61d5b&"
import script from "./WidgetMenu.vue?vue&type=script&lang=ts&"
export * from "./WidgetMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports